import React from 'react';
import { ScribeGuide } from '@/components/help/ScribeGuide';
import { ScribeManager } from '@/components/help/ScribeManager';

const TestScribe: React.FC = () => {
  return (
    <div className="p-8 space-y-8">
      <h1 className="text-3xl font-bold">Scribehow Integration Test</h1>
      
      <div className="space-y-4">
        <h2 className="text-2xl font-semibold">1. Direct ScribeGuide Component</h2>
        <ScribeGuide
          url="https://scribehow.com/shared/How_To_Add_A_Class_In_Hivetivity_Dashboard__HwlvFSyVQ4i-_HpJnQ44lA"
          title="How to Add a Class"
          description="Direct embed test"
          mode="slides"
          category="Test"
          difficulty="beginner"
        />
      </div>

      <div className="space-y-4">
        <h2 className="text-2xl font-semibold">2. ScribeManager Component</h2>
        <ScribeManager 
          showSearch={true}
        />
      </div>

      <div className="space-y-4">
        <h2 className="text-2xl font-semibold">3. Database Integration</h2>
        <p className="bg-green-100 p-4 rounded text-green-800">
          Now using database instead of static file data! 
          Guides are loaded from the scribe_guides table.
        </p>
      </div>
    </div>
  );
};

export default TestScribe;